<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="地学资料列表" name="1">
      <DxzlAdd :updataID='updataID'></DxzlAdd>
    </el-tab-pane>
    <el-tab-pane label="分类管理列表" name="2"></el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 何宽
 * 地学资料修改
 */
import DxzlAdd from '../../../../static/form/DxzlAdd.vue'
export default {
  components: {
    DxzlAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Dxzlgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/DxzlUpdate.vue